import React, { ReactNode, useEffect, useRef } from 'react';
import './ModalOverlay.css';

type Props = {
    children: React.ReactNode;
    onClose: () => void;
};

const ModalOverlay = ({ onClose, children }: Props) => {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onClose();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className="modal-overlay">
            <div className="scrollable-modal" ref={modalRef}>
                {children}
            </div>
        </div>
    );
};

export default ModalOverlay;